module.exports = __webpack_public_path__ + "static/media/home2_landscape.20b900b2.png";